<template>
  <div>
    <title>快递打印列表</title>
     <section class="orderSect">
      <!--S 检索-->      
      <el-form :inline="true" :model="printFormInline">
        <el-form-item label="快递生成日期">
          <el-date-picker v-model="printFormInline.expressDate" type="daterange" range-separater="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="printFormInline.expressDateOptions"
          :unlink-panels = "true" clearable></el-date-picker>
        </el-form-item>
        <el-form-item label="订单号" class="codeSerIpt">
          <el-input v-model="printFormInline.orderno" placeholder="请输入订单号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getExpBatchList">查询</el-button>
        </el-form-item>
      </el-form>
      <!--E 检索-->

      <!--S 快递打印列表-->
      <div class="allOrderTab individualiz">
        <el-form inline size="medium">
          <el-form-item>
            <el-button type="primary" plain @click="orderCollection()">非打印单号采集</el-button>
            <el-button type="primary" plain @click="getPrinted()">勾选打印</el-button>
            <el-button type="primary" plain @click="exportSend(0)">导出即发货</el-button>
            <el-button type="primary" plain @click="exportSend(1)">导出待发货</el-button>
            <el-button type="primary" plain @click="improveExpress()">完善快递</el-button>
          </el-form-item>
        </el-form>
        <el-table v-loading="loading" :data="expressPrintData" ref="expressTable" class="orderTable comTable" border :maxHeight="tableHeight"  @selection-change="handleSelectionChange">
            <el-table-column type="selection" :selectable="disTable"></el-table-column>         
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column label="快递生成日期" sortable prop="expgendate" min-width="180px">
              <template slot-scope="scope">{{ dateTime(scope.row.expgendate, 1)}}</template>
            </el-table-column>
            <el-table-column label="快递数量" sortable prop="expnum" min-width="180px">
              <template slot-scope="scope">{{scope.row.expnum}}</template>
            </el-table-column>
            <el-table-column label="打印备注" sortable prop="memo" min-width="220px">
              <template slot-scope="scope"><p class="textFl">{{scope.row.memo}}</p></template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="150">
              <template slot-scope="scope">
                <el-dropdown trigger="click" :title="scope.row.bank" @command="handleCommand" placement="bottom-start">
                  <span class="el-dropdown-link">
                    全部操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="{'type':'expressDetail', 'expgenbatchno':scope.row.expgenbatchno}">详情</el-dropdown-item>
                    <div>
                      <el-dropdown-item :command="{'type': 'print', 'printType':1000, 'expgenbatchno':scope.row.expgenbatchno,'breturn':scope.row.breturn}">针式打印</el-dropdown-item>
                      <el-dropdown-item v-if="opend_printTypes.indexOf(1) != -1" :command="{'type': 'print', 'printType':1, 'expgenbatchno':scope.row.expgenbatchno,'breturn':scope.row.breturn}">顺丰热敏</el-dropdown-item>
                      <el-dropdown-item v-if="opend_printTypes.indexOf(2) != -1" :command="{'type': 'print', 'printType':2, 'expgenbatchno':scope.row.expgenbatchno,'breturn':scope.row.breturn}">圆通热敏</el-dropdown-item>
                      <el-dropdown-item v-if="opend_printTypes.indexOf(40) != -1" :command="{'type': 'print', 'printType':40, 'expgenbatchno':scope.row.expgenbatchno,'breturn':scope.row.breturn}">联邦热敏</el-dropdown-item>
                      <el-dropdown-item v-if="opend_printTypes.indexOf(79) != -1" :command="{'type': 'print', 'printType':79, 'expgenbatchno':scope.row.expgenbatchno,'breturn':scope.row.breturn}">韵达热敏</el-dropdown-item>
                      <el-dropdown-item v-if="opend_printTypes.indexOf(90) != -1" :command="{'type': 'print', 'printType':90, 'expgenbatchno':scope.row.expgenbatchno,'breturn':scope.row.breturn}">京东热敏</el-dropdown-item>
                      <el-dropdown-item v-if="opend_printTypes.indexOf(97) != -1" :command="{'type': 'print', 'printType':97, 'expgenbatchno':scope.row.expgenbatchno,'breturn':scope.row.breturn}">安能热敏</el-dropdown-item>
                      <el-dropdown-item v-if="opend_printTypes.indexOf(100) != -1" :command="{'type': 'print', 'printType':100, 'expgenbatchno':scope.row.expgenbatchno,'breturn':scope.row.breturn}">跨越热敏</el-dropdown-item>
                      <el-dropdown-item v-if="opend_printTypes.indexOf(107) != -1" :command="{'type': 'print', 'printType':107, 'expgenbatchno':scope.row.expgenbatchno,'breturn':scope.row.breturn}">京东云仓</el-dropdown-item>
                      <el-dropdown-item v-if="opend_printTypes.indexOf(110) != -1" :command="{'type': 'print', 'printType':110, 'expgenbatchno':scope.row.expgenbatchno,'breturn':scope.row.breturn}">菜鸟热敏</el-dropdown-item>
                      <el-dropdown-item v-if="opend_printTypes.indexOf(111) != -1" :command="{'type': 'print', 'printType':111, 'expgenbatchno':scope.row.expgenbatchno,'breturn':scope.row.breturn}">承诺达</el-dropdown-item>
                      <el-dropdown-item :command="{'type':'orderCollection', 'expgenbatchno':scope.row.expgenbatchno}">单号采集</el-dropdown-item>
                      <el-dropdown-item :command="{'type':'ResetToIssued', 'expgenbatchno':scope.row.expgenbatchno}" v-show="scope.row.breturn == 0">重置待发</el-dropdown-item>
                      <el-dropdown-item :command="{'type':'exportShipped', 'expgenbatchno':scope.row.expgenbatchno}" v-show="scope.row.breturn == 0">导出待发货</el-dropdown-item>
                      <el-dropdown-item :command="{'type':'exportDelivery', 'expgenbatchno':scope.row.expgenbatchno}" v-show="scope.row.breturn == 0">导出即发货</el-dropdown-item>
                    </div>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="noData"><span>暂无数据</span></div>
            </template>
        </el-table>
      </div>
      <!--S 快递打印列表-->
      <Page :pageTotal="pagebean.totalnum" :currentPage="pagebean.currentpage" @nowPageParam="setPageparam"></Page>
    </section>

    <!--S 选择打印方式-->
    <el-dialog :visible.sync="seniorShow" class="comDlog seniorMdg" :before-close="closeSeniorBox" append-to-body :close-on-click-modal="false">
      <div slot="title" class="dialog-title">批量打印</div>
      <el-form :model="seniorForm" label-width="100px">
        <el-form-item label="打印类别">
          <el-select v-model="seniorForm.printWay" clearable placeholder="请选择" @change="printWaySel()">
            <el-option v-for="(item,index) in printWayList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>            
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeSeniorBox(1)">确定</el-button>
        <el-button @click="closeSeniorBox(0)">取消</el-button>
      </div>
    </el-dialog>
    <!--E 选择打印方式-->
    
    <!--S 完善快递弹窗组件-->
    <ImproveExpress :loadingShow="subLoading" :improveExpressBox="improveShow" :collectedShow="collected" @closeIEVal="clsBtnVal" @closeIEBox="closeImproveExpress"></ImproveExpress>
    <!--E 完善快递弹窗组件-->


  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import api from '../../apis/api';
import {dateTime} from '../../util/dateTime';
export default {
  name: 'AddExpress',
  data () {
    return {
      printFormInline:{
        orderno: "", //订单号
        expressDate: "", //快递生成日期
        expressDateOptions: {
          shortcuts: [
            {
              text: "今天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime());
                picker.$emit("pick", [start, end]);
              }
            },{
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              }
            }
          ]
        },
      },
      expressPrintData:[
      ],//打印列表数据
      multipleSelection: [], //已选中的行
      tableHeight: window.innerHeight * 0.8, //表格动态高度
      seniorShow:false, //选择打印类别
      seniorForm:{
        printWay:'',
      },
      printWayList: [ //打印类别
      ],
      printType:'',//打印类别
      improveShow:false, //完善快递的弹窗
      improveEprBtnVal:'',//关闭完善快递弹窗是确定还是取消
      collected:true,//是否展示快递方式
      pagebean: {
        pagesize: 30,
        currentpage: 1
      },//分页
      loading: true,//加载
      expgenbatchnoArr: [],//批次编号数组
      opend_printTypes: [],//已开通的快递处理方式
      patchName: '', // 获取上一个页面的name
      subLoading: false, // 弹窗提交按钮遮罩显示隐藏
    }
  },
  watch: {
    '$route'(to,from) {
      this.patchName = from.name;
    }
  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
    ImproveExpress: resolve => require(["@/components/DeliveryFolder/ImproveExpress.vue"], resolve), //完善快递组件
  },
  methods: {
    //表格多选选中行
    handleSelectionChange(val) { 
      this.multipleSelection = val;
    },
    //非打印单号采集
    orderCollection(){
      if(this.multipleSelection.length > 0){ //勾选
        //缓存参数
        this.expgenbatchnoArr = []
        this.multipleSelection.forEach(item => {
          this.expgenbatchnoArr.push(item.expgenbatchno)
        })
        sessionStorage.setItem('expgenbatchnoArr', JSON.stringify(this.expgenbatchnoArr))
        this.$router.push({
          name:'单号采集列表',
          params: {
            nonOddCollection:true, //是否展示快递方式
          }
        }); 
      }else{
        MessageBox.alert('请勾选你要采集单号的快递批次？', '系统提示', {
          confirmButtonText: '确定',
          type:'warning'
        }).then(() => {}).catch(() => {});
      } 
    },
    //勾选打印
    getPrinted(){
      if(this.multipleSelection.length > 0){ //勾选
        this.seniorShow = true; 
      }else{
        MessageBox.alert('请勾选你要打印的快递批次？', '系统提示', {
          confirmButtonText: '确定',
          type:'warning'
        }).then(() => {}).catch(() => {});
      } 
    },
    //打印类别选择
    printWaySel(){
      console.log(this.seniorForm.printWay,'123');
      this.printType = this.seniorForm.printWay;
    },
    //关闭打印类别弹窗
    closeSeniorBox(val){
      if(val === 1){
        this.seniorShow = false;
        if(this.printType != '1004' && this.printType != '1005' && this.printType != '1006' && this.printType != '1007' && this.printType != '1009') {
          //缓存批次参数
          this.expgenbatchnoArr = []
          this.multipleSelection.forEach(item => {
            this.expgenbatchnoArr.push(item.expgenbatchno)
          })
          sessionStorage.setItem('expgenbatchnoArr', JSON.stringify(this.expgenbatchnoArr))
          this.$router.push({
            name:'针式热敏打印列表',
            params: {
              printType: this.printType ? this.printType : this.seniorForm.printWay,
            },
          });
        } else {
          let type = this.printType == '1004' ? 2 : (this.printType == '1005' ? 1 : (this.printType == '1006' ? 0 : (this.printType == '1009'?5:3)))
          this.$router.push({
            name:'ERP发货记录',
            query: {
              type: type,
              subNow: this.subNow,
            }
          });
        }
      } else {
        this.seniorShow = false;
      }
    },
    //导出待发货、导出即发货
    exportSend(val){
      if(this.multipleSelection.length > 0){ //勾选
        //组装需要操作的快递批次编号
        this.expgenbatchnoArr = []//清空参数
        this.multipleSelection.forEach(item => {
          this.expgenbatchnoArr.push(item.expgenbatchno)
        })
        if(val == 1){//导出待发货
          this.exportExpgenbatch()
        }else{ //导出即发货
          MessageBox.confirm('导出即发货直接将订单变为已发货且无法撤回无法采集单号，如需采集单号请用导出待发货操作，针对该批次有电商监管订单的强烈建议使用旁边的【导出待发货】功能。是否继续?', '信息确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.exportExpgenbatchDelivery()
          }).catch(() => {});
        }
      }else{
        MessageBox.alert('请勾选你要导出的快递批次？', '系统提示', {
          confirmButtonText: '确定',
          type:'warning'
        }).then(() => {}).catch(() => {});
      }
    },
    //完善快递
    improveExpress(){
      this.improveShow = true;
    },
    //关闭完善快递是确定还是取消
    clsBtnVal(val){
      this.improveEprBtnVal = val;
    },
    //关闭完善快递弹窗
    closeImproveExpress(formData, fileUrl){
      if(Number(this.improveEprBtnVal)){
        this.subLoading = true;
        let data = JSON.parse(formData)
        let params = {
          perfect: fileUrl,//文件地址
          sendinfocode: data.sender,//寄件人
          exptype: data.expressWay,//快递方式
          expmoney: data.expressAmount,//快递费用
          issend: data.notice ? 1 : 0,
          sendMsgDate: data.messageDate?this.dateTime(data.messageDate,1):'',//发送日期
        }
        api.PERFECTEXPINFO(params).then(res => {
          if(res.data.status == '200') {
            Message({
              type: 'success',
              message: '完善快递成功!'
            });
            this.getExpBatchList()
            this.improveShow = false; //完善快递弹窗
          } else {
            this.subLoading = false;
            Message({
              type: 'error',
              message: res.data.message
            });
          }
        })
      } else {
        this.improveShow = false; //完善快递弹窗
      }
    },
    //操作指令
    handleCommand(command) {
      if(command.type == 'expressDetail'){ //详情
        this.$router.push({
          name:'快递打印列表详情', 
          params: {
            expgenbatchno: command.expgenbatchno,
          }
        });
      }else if(command.type == 'print'){ //打印 
        this.expgenbatchnoArr = []
        this.expgenbatchnoArr.push(command.expgenbatchno) 
        sessionStorage.setItem('expgenbatchnoArr', JSON.stringify(this.expgenbatchnoArr))
        this.$router.push({
          name:'针式热敏打印列表',
          params: {
            printType: command.printType,
          },
          query: {
            breturn: command.breturn
          }
        });
      }else if(command.type == 'orderCollection'){ //单号采集
        this.expgenbatchnoArr = []
        this.expgenbatchnoArr.push(command.expgenbatchno) 
        sessionStorage.setItem('expgenbatchnoArr', JSON.stringify(this.expgenbatchnoArr))
        this.$router.push({
          name:'单号采集列表',
          params: {
            nonOddCollection:false, //是否展示快递方式
          }
        });  
      }else if(command.type == 'ResetToIssued'){ //重置待发
        MessageBox.confirm('确定执行【重置待发】操作?', '信息确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //调用重置待发接口
          this.rollBack(command.expgenbatchno)
        }).catch(() => {});
      }else if(command.type == 'exportShipped'){ //导出待发货
        //自动下载excel文件
        this.expgenbatchnoArr = []
        this.expgenbatchnoArr.push(command.expgenbatchno)
        this.exportExpgenbatch()
      }else if(command.type == 'exportDelivery'){ //导出即发货
        MessageBox.confirm('导出即发货直接将订单变为已发货且无法撤回无法采集单号，如需采集单号请用导出待发货操作，针对该批次有电商监管订单的强烈建议使用旁边的【导出待发货】功能。是否继续?', '信息确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //自动下载excel文件
          console.log('即发货下载excel文件');
          this.expgenbatchnoArr = []
          this.expgenbatchnoArr.push(command.expgenbatchno)
          this.exportExpgenbatchDelivery()
        }).catch(() => {});
      }
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.expressTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130;
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
    },

    //设置分页数据
    setPageparam(nowPageSize, nowCurrentPage) {
      if(nowPageSize) {
        this.pagebean.pagesize = nowPageSize
      }
      if(nowCurrentPage) {
        this.pagebean.currentpage = nowCurrentPage
      }
      this.getExpBatchList()
    },

    //查询列表
    getExpBatchList() {
      this.loading = true
      let params = {
        stardate: this.printFormInline.expressDate && this.printFormInline.expressDate[0] ? this.dateTime(this.printFormInline.expressDate[0]) : '',
        enddate: this.printFormInline.expressDate && this.printFormInline.expressDate[1] ? this.dateTime(this.printFormInline.expressDate[1]) : '',
        orderno: this.printFormInline.orderno, //订单号
        pageparam: this.pagebean
      }
      api.LISTEXPGENBATCH(params).then(res => {
        if(res.data.status == '200') {
          this.expressPrintData = res.data.data
          this.pagebean = res.data.pagebean
        } else {
          this.expressPrintData = []
        }
        this.loading = false
      })
    },

    //获取可用的快递列表
    getPrintTypes() {
      api.GET_SHOWPRINT({}).then(res => {
        this.printWayList = res.data.data
        this.opend_printTypes = []
        this.printWayList.forEach(item => {
          if(item.bdefault == 1) {
            this.seniorForm.printWay = item.value
            this.printType = item.value
          }
          this.opend_printTypes.push(item.value)
        })
      })
    },

    //重置待发
    rollBack(expgenbatchno) {
      this.loading = true
      api.UPDATEEXPINFOROLLBACK({'expgenbatchno': expgenbatchno}).then(res => {
        if(res.data.status == '200') {
          this.getExpBatchList()
          Message({  //成功提示
            type: 'success',
            message: '【重置待发】操作成功!'
          });
        } else {
          Message({  //失败提示
            type: 'error',
            message: res.data.message ? res.data.message : '重置待发失败，请刷新重试！'
          });
        }
        this.loading = false
      })
    },

    //导出待发货
    exportExpgenbatch() {
      this.loading = true
      api.EXPORTEXPGENBATCH({'expgenbatchnoArr': this.expgenbatchnoArr}).then(res => {
        if(res.data.status == '200') {
          Message({  //失败提示
            type: 'success',
            message: '导出成功'
          });
          window.location.href = res.data.data
        } else {
          Message({  //失败提示
            type: 'error',
            message: res.data.message ? res.data.message : '导出失败，请刷新重试！'
          });
        }
        this.loading = false
      })
    },

    exportExpgenbatch() {
      this.loading = true
      api.EXPORTEXPGENBATCH({'expgenbatchnoArr': this.expgenbatchnoArr}).then(res => {
        if(res.data.status == '200') {
          Message({  //失败提示
            type: 'success',
            message: '导出成功'
          });
          window.location.href = res.data.data
        } else {
          Message({  //失败提示
            type: 'error',
            message: res.data.message ? res.data.message : '导出失败，请刷新重试！'
          });
        }
        this.loading = false
      })
    },
    
    //导出即发货
    exportExpgenbatchDelivery() {
      this.loading = true
      api.EXPORTEXPGENBATCHDELIVER({'expgenbatchnoArr': this.expgenbatchnoArr}).then(res => {
        if(res.data.status == '200') {
          Message({  //失败提示
            type: 'success',
            message: '导出成功'
          });
          window.location.href = res.data.data
        } else {
          Message({  //失败提示
            type: 'error',
            message: res.data.message ? res.data.message : '导出失败，请刷新重试！'
          });
        }
        this.loading = false
      })
    },

    disTable(row) {
      if(row.breturn == 0) {
        return true;
      }
      return false
    },

  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    //在dom渲染之后
    setTimeout(() => {
      this.getHeight();
      this.getExpBatchList()
      this.getPrintTypes()
    }, 200);
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight); //销毁监听浏览器视窗变化
  },
  activated() {
    if(this.patchName == '针式热敏打印列表' || this.patchName == '单号采集列表' || this.patchName == '快递打印列表详情') {
      if(this.patchName == '针式热敏打印列表' || this.patchName == '单号采集列表') {
        this.getExpBatchList();
      }
    } else {
      if(this.patchName) {
        this.printFormInline.orderno = '';
        this.printFormInline.expressDate = '';
        this.pagebean = {
          pagesize: 30,
          currentpage: 1
        }
        setTimeout(() => {
          this.getHeight();
          this.getExpBatchList()
          this.getPrintTypes()
        }, 200);
      }
    }
  },
}
</script>

<style scoped>
@import "Css/Style.css";
.individualiz >>> form {padding-top:15px!important;}

/*选择打印方式*/
.seniorMdg >>> .el-dialog {width:500px;}
.seniorMdg >>> .el-form-item__content {width:65%; min-width: 200px; max-width: 340px;}
.seniorMdg >>> .el-form-item__content .el-select {width:100%;}

</style>



// WEBPACK FOOTER //
// src/views/DeliveryFolder/ExpressPrintList.vue